<template>
  <div class="content-container">
    <!-- Search Component -->
    <search-comp
      :search-show="true"
      @onSearch="onSearch"
      @onReset="onResetParams"
    >
      <template>
        <div class="das-form-container">
          <div class="das-form-group">
            <div class="das-form-row align-end">
              <div class="das-form-col col-3">
                <div class="das-form-input">
                  <div class="label required">Thu ngân</div>
                  <el-select
                    v-model="searchParams.cashierUserId"
                    filterable
                    placeholder="Chọn thu ngân"
                  >
                    <el-option
                      v-for="(item, index) in cashierOption"
                      :key="index"
                      :value="item.id"
                      :label="item.full_name"
                    ></el-option>
                  </el-select>
                </div>
              </div>
              <div class="das-form-col col-3">
                <div class="das-form-input">
                  <div class="label">Ngày</div>
                  <div class="flex gap-10">
                    <CalendarSelect
                      v-model="searchParams.date"
                      style="width: 100%"
                      mode="date"
                    />
                    <!-- :min-max="minMaxDate" -->
                  </div>
                </div>
              </div>
              <div class="das-form-col col-3">
                <div class="das-form-input">
                  <div class="label">Quầy</div>
                  <el-select
                    v-model="searchParams.ticketOfficeId"
                    filterable
                    placeholder="Chọn quầy"
                  >
                    <el-option
                      v-for="(item, index) in ticketOfficeOption"
                      :key="index"
                      :value="item.id"
                      :label="item.name"
                    ></el-option>
                  </el-select>
                </div>
              </div>
            </div>
          </div>
        </div>
      </template>
    </search-comp>
    <div class="flex column gap-0 flex-1">
      <tab v-model="tabIndex" :tab-list="tabList" @input="onTabChange" />
      <div v-loading="loading" class="grid-scroll mt-10">
        <GridVx
          ref="agGrid"
          :columns="columns"
          :auto-size-cell="true"
          dom-layout="scroll"
          :rows="rows"
          class="agGrid"
          style="height: 558px"
          :context="context"
          :pinned-bottom-row-data="pinnedRowData"
          @refresh="onRefresh"
        />
      </div>
      <!-- <div class="grid-botton">
        <GridPaging
          target="masterGroupTable"
          :total-size="pagination.totalPage"
          :page-num="pagination.currentPage"
          @pageChanged="onPageChanged($event)"
          @onPageSizeChange="onPageSizeChanged($event)"
        />
      </div> -->
    </div>

    <el-dialog
      :title="'Không xác nhận'"
      :visible.sync="dialogFormVisible"
      :close-on-click-modal="false"
      width="500px"
    >
      <validation-observer ref="formValidator">
        <div class="das-form-container">
          <div class="das-form-group">
            <div class="das-form-row">
              <div class="das-form-col col-9">
                <validation-provider rules="required" :name="'Lý do'">
                  <div class="das-form-input">
                    <div class="label required">{{ $t('dialog.reason') }}</div>
                    <div class="child-w-80">
                      <input v-model="reason" type="text" />
                    </div>
                  </div>
                </validation-provider>
              </div>
            </div>
          </div>
        </div>
      </validation-observer>
      <span slot="footer" class="dialog-footer">
        <div class="button-containers">
          <button
            class="btn primary small outline"
            @click="dialogFormVisible = false"
          >
            {{ $t('button.cancel') }}
          </button>
          <button class="btn primary small" @click="onUpdateReason">
            {{ $t('button.confirm') }}
          </button>
        </div>
      </span>
    </el-dialog>
    <el-dialog
      :title="'Cảnh báo'"
      :visible.sync="dialogConfirmVisible"
      :close-on-click-modal="false"
      width="500px"
    >
      <validation-observer ref="formValidator">
        <div class="das-form-container">
          <div class="das-form-group">
            <div class="das-form-row">
              <div class="das-form-col col-12">
                <span
                  >Trạng thái sẽ không thể thay đổi lại khi nhấn xác nhận!</span
                >
              </div>
            </div>
          </div>
        </div>
      </validation-observer>
      <span slot="footer" class="dialog-footer">
        <div class="button-containers">
          <button
            class="btn primary small outline"
            @click="dialogConfirmVisible = false"
          >
            {{ $t('button.cancel') }}
          </button>
          <button class="btn primary small" @click="onConfirm">
            {{ $t('button.confirm') }}
          </button>
        </div>
      </span>
    </el-dialog>
  </div>
</template>

<script>
/* eslint-disable */
import bus from '@/utils/bus'
import {
  getCashList,
  getTicketOfficeList,
  getCashierList,
  updateCashList,
  getPermissionToConfirm
} from '@/api/accounting/cashList'
import { checkAuthorized } from '@/utils/helper'
import { CellRenderNumberInput } from '@/utils/cellRenders.js'
import ApproveCellRenderer from './components/ApproveCellRenderer.vue'
import Tab from '@/components/Tab'
export default {
  components: {
    CellRenderNumberInput,
    ApproveCellRenderer,
    Tab
  },
  data() {
    return {
      loading: false,
      context: null,
      cashierOption: [],
      ticketOfficeOption: [],
      pinnedRowData: [
        {
          no: null,
          denomination: 'Tổng cộng',
          quantity: 0,
          total: 0,
          quantity_a: 0,
          total_a: 0,
          status: null
        }
      ],
      columns: [
        {
          headerName: 'STT',
          field: 'no',
          minWidth: 60,
          maxWidth: 60,
          headerClass: ['header-row-span-2']
        },
        {
          headerName: 'Mệnh giá',
          headerTooltip: 'Mệnh giá',
          field: 'denomination',
          tooltipField: 'denomination',
          headerClass: ['header-row-span-2'],
          cellRenderer: params => {
            if (params.node.rowPinned !== 'bottom') {
              if (params.rowIndex <= 9)
                return Number(params.value).toLocaleString('en-US')
              else return params.value
            } else return params.value
          }
        },
        {
          headerName: 'Thu ngân nộp',
          children: [
            {
              headerName: 'Số lượng',
              headerTooltip: 'Số lượng',
              tooltipField: 'quantity',
              field: 'quantity',
              cellRenderer: params => {
                if (params.node.rowPinned !== 'bottom') {
                  if (params.rowIndex <= 9)
                    return Number(params.value).toLocaleString('en-US')
                  else return params.value
                } else return Number(params.value).toLocaleString('en-US')
              },
              cellClass: 'grid-cell-right'
            },
            {
              headerName: 'Thành tiền',
              headerTooltip: 'Thành tiền',
              tooltipField: 'total',
              field: 'total',
              cellRenderer: params => {
                if (params.node.rowPinned !== 'bottom') {
                  if (params.rowIndex <= 9)
                    return Number(params.value).toLocaleString('en-US')
                  else return params.value
                } else return Number(params.value).toLocaleString('en-US')
              },
              cellClass: 'grid-cell-right'
            }
          ]
        },
        {
          headerName: 'Kế toán nhận',
          children: [
            {
              headerName: 'Số lượng',
              field: 'quantity_a',
              cellRendererSelector: params => {
                if (!params.data.is_able_to_insert) {
                  return {
                    component: null
                  }
                }
                // if (params.data.account_status !== 0) {
                //   return {
                //     component: null
                //   }
                // }
                if (params.node.rowPinned !== 'bottom') {
                  if (params.rowIndex <= 9) {
                    return {
                      component: 'CellRenderNumberInput',
                      params: {
                        colName: 'quantity_a',
                        textAlign: 'right'
                      }
                    }
                  } else {
                    return {
                      component: null
                    }
                  }
                } else {
                  return {
                    component: null
                  }
                }
              },
              cellClass: 'grid-cell-right'
            },
            {
              headerName: 'Thành tiền',
              headerTooltip: 'Thành tiền',
              tooltipField: 'total_a',
              field: 'total_a',
              cellRenderer: params => {
                if (params.node.rowPinned !== 'bottom') {
                  if (params.rowIndex <= 9)
                    return Number(params.value).toLocaleString('en-US')
                  else return params.value
                } else return Number(params.value).toLocaleString('en-US')
              },
              cellClass: 'grid-cell-right',
              headerClass: 'last-header-cell-group'
            }
          ],
          headerClass: [
            'header-cell-suffix-group',
            'header-cell-center',
            'header-group-cell-divide'
          ]
        },
        {
          headerName: 'Tình trạng',
          field: 'status',
          // tooltipField: 'status',
          cellRendererSelector: params => {
            if (params.node.rowPinned === 'bottom')
              return {
                component: 'ApproveCellRenderer',
                params: {
                  hasConfirmPermission: this.hasConfirmPermission
                }
              }
          },
          maxWidth: 100,
          minWidth: 100,
          headerClass: [
            'header-row-span-2',
            'header-cell-suffix-group',
            'header-cell-center'
          ]
        }
      ],
      rows: [
        // {
        //   no: 1,
        //   quantity: 2,
        //   money: 500000,
        //   status: 0
        // }
      ],
      selectedRow: null,
      pagination: {
        totalPage: 0,
        currentPage: 0
      },

      dialogFormVisible: false,
      dialogConfirmVisible: false,
      searchParams: {
        date: this.$moment().format('YYYY-MM-DD'),
        cashierUserId: null,
        ticketOfficeId: null,
        pageSize: 10,
        pageNum: 1
      },
      tabIndex: null,
      tabList: [],
      reason: null,
      isAccept: false,
      cashData: [],
      hasConfirmPermission: false
    }
  },
  watch: {},
  beforeMount() {
    this.context = { componentParent: this }
  },
  async mounted() {
    // this.fnGetCashList()
    // this.fnGetPermissionToConfirm()
    this.hasConfirmPermission = checkAuthorized('CASH_STATEMENT_CONFIRM')
    this.fnGetTicketOfficeList()
    this.fnGetCashierList()
  },
  computed: {
    minMaxDate() {
      return {
        max: this.$moment().format('YYYY-MM-DD'),
        min: this.$moment().subtract(3, 'd').format('YYYY-MM-DD')
      }
    }
  },
  methods: {
    // tab
    async onTabChange(idx) {
      this.tabIndex = idx
      if (this.cashData[idx - 1].account_status === 0) {
        this.rows =
          this.cashData[idx - 1]?.cashier_list.map((item, index) => {
            return {
              ...item,
              no: index + 1,
              is_able_to_insert: this.cashData[idx - 1].is_able_to_insert,
              quantity_a: index <= 9 ? 0 : '',
              total_a: index <= 9 ? 0 : ''
            }
          }) || []
      } else {
        this.rows =
          this.cashData[idx - 1]?.cashier_list.map((item, index) => {
            return {
              ...item,
              no: index + 1,
              is_able_to_insert: this.cashData[idx - 1].is_able_to_insert,
              quantity_a:
                this.cashData[idx - 1]?.accountant_list[index].quantity,
              total_a: this.cashData[idx - 1]?.accountant_list[index].total
            }
          }) || []
      }
      this.pinnedRowData = [
        {
          denomination: 'Tổng cộng',
          quantity: this.cashData[idx - 1].cashier_quantity || 0,
          total: this.cashData[idx - 1].cashier_total || 0,
          quantity_a: this.cashData[idx - 1].accountant_quantity || 0,
          total_a: this.cashData[idx - 1].accountant_total || 0,
          status: this.cashData[idx - 1].account_status
        }
      ]
    },

    // search, reset, pagination
    onResetParams() {
      this.searchParams = {
        date: this.$moment().format('YYYY-MM-DD'),
        cashierUserId: null,
        ticketOfficeId: null,
        pageSize: 10,
        pageNum: 1
      }
      this.tabIndex = -1
      this.tabList = []
      this.rows = []
      this.pinnedRowData = [
        {
          no: null,
          denomination: 'Tổng cộng',
          quantity: 0,
          total: 0,
          quantity_a: 0,
          total_a: 0,
          status: null
        }
      ]
      this.fnGetCashList()
    },
    onRefresh(data) {
      let params = {
        orderBy: data.orderBy,
        orderTp: data.sort
      }
      this.searchParams = { ...this.searchParams, ...params }
      this.fnGetCashList()
    },
    async fnGetCashList() {
      if (
        this.searchParams.cashierUserId === null ||
        this.searchParams.cashierUserId === ''
      ) {
        this.$message({
          type: 'error',
          message: 'Chọn thu ngân trước khi tìm kiếm.'
        })
        return
      }
      this.loading = true
      await getCashList(this.searchParams)
        .then(res => {
          this.cashData = res.data
          // this.pagination.totalPage = res.total
        })
        .catch(error => {
          this.$message({
            type: 'error',
            message: this.$t(
              'errorMsg.' + error?.response?.data?.message
                ? error?.response?.data?.message
                : error
            )
          })
        })
        .finally(() => {
          this.tabList =
            this.cashData.map((item, index) => {
              return {
                label: item.ticket_office_name,
                id: item.id,
                idx: index
              }
            }) || []
          this.tabIndex = this.cashData[0]?.id ? 1 : -1
          if (this.cashData.length > 0) {
            if (this.cashData[0].account_status === 0) {
              this.rows =
                this.cashData[0]?.cashier_list.map((item, index) => {
                  return {
                    ...item,
                    no: index + 1,
                    is_able_to_insert: this.cashData[0].is_able_to_insert,
                    quantity_a: index <= 9 ? 0 : '',
                    total_a: index <= 9 ? 0 : ''
                  }
                }) || []
            } else {
              this.rows =
                this.cashData[0]?.cashier_list.map((item, index) => {
                  return {
                    ...item,
                    no: index + 1,
                    is_able_to_insert: this.cashData[0].is_able_to_insert,
                    quantity_a:
                      this.cashData[0]?.accountant_list[index].quantity,
                    total_a: this.cashData[0]?.accountant_list[index].total
                  }
                }) || []
            }
            this.pinnedRowData = [
              {
                denomination: 'Tổng cộng',
                quantity: this.cashData[0].cashier_quantity || 0,
                total: this.cashData[0].cashier_total || 0,
                quantity_a: this.cashData[0].accountant_quantity || 0,
                total_a: this.cashData[0].accountant_total || 0,
                status: this.cashData[0].account_status
              }
            ]
          } else {
            this.rows = []
            this.pinnedRowData = [
              {
                denomination: 'Tổng cộng',
                quantity: 0,
                total: 0,
                quantity_a: 0,
                total_a: 0,
                status: null
              }
            ]
          }

          this.loading = false
        })
    },
    async fnGetTicketOfficeList() {
      await getTicketOfficeList()
        .then(res => {
          this.ticketOfficeOption = res.data
        })
        .catch(error => {
          this.$message({
            type: 'error',
            message: this.$t(
              'errorMsg.' + error?.response?.data?.message
                ? error?.response?.data?.message
                : error
            )
          })
        })
    },
    async fnGetCashierList() {
      await getCashierList()
        .then(res => {
          this.cashierOption = res.data.map(item => {
            return {
              id: item.account.id,
              username: item.account.username,
              full_name: item.account.full_name,
              cashier_account: item.account.cashier_account
            }
          })
        })
        .catch(error => {
          this.$message({
            type: 'error',
            message: this.$t(
              'errorMsg.' + error?.response?.data?.message
                ? error?.response?.data?.message
                : error
            )
          })
        })
    },
    openDialog() {
      this.dialogFormVisible = true
    },
    onPageChanged(pageNum) {
      this.searchParams.pageNum = pageNum
      this.fnGetCashList()
    },
    onPageSizeChanged(pageSize) {
      this.searchParams.pageSize = pageSize
      this.searchParams.pageNum = 1
      this.fnGetCashList()
    },

    async onSearch() {
      this.searchParams.pageNum = 1
      await this.fnGetCashList()
    },
    textInputChange(params, value, colName) {
      const rowIdx = params.rowIndex
      this.rows[rowIdx]['quantity_a'] = value
      this.rows[rowIdx]['total_a'] = value * params.data.denomination || 0
      this.$refs.agGrid.gridOptions.api.forEachNode(node => {
        if (node.rowIndex === rowIdx) {
          node.setData(params.data)
        }
      })
      var total_a = 0
      var quantity_a = 0
      this.rows.map((item, index) => {
        quantity_a = quantity_a + item.quantity_a || 0
        total_a = total_a + item.total_a
      })
      this.pinnedRowData = [
        {
          no: null,
          denomination: 'Tổng cộng',
          quantity: this.pinnedRowData[0].quantity,
          total: this.pinnedRowData[0].total,
          quantity_a: quantity_a,
          total_a: total_a,
          status: this.pinnedRowData[0].status
        }
      ]
    },
    updateStatus(params, value) {
      // this.$alert(
      //   'Trạng thái sẽ không thể thay đổi lại khi nhấn xác nhận',
      //   'Xác nhận',
      //   {
      //     confirmButtonText: 'Xác nhận',
      //     confirmButtonClass: 'btn primary small',
      //     callback: action => {
      //       this.dialogFormVisible = true
      //     }
      //   }
      // )
      if (!this.cashData[this.tabIndex - 1].is_able_to_insert) {
        this.$message({
          type: 'error',
          message: 'Quá hạn để cập nhật tình trạng'
        })
        return
      }
      this.selectedRow = params
      this.isAccept = value
      this.dialogConfirmVisible = true
    },
    onConfirm() {
      if (this.isAccept) this.fnChangeStatus(1)
      else {
        this.dialogConfirmVisible = false
        this.dialogFormVisible = true
      }
    },
    onUpdateReason() {
      if (this.reason === null || this.reason === '') {
        this.$message({
          type: 'error',
          message: 'Vui lòng nhập lý do'
        })
        return
      }
      this.fnChangeStatus(2)
    },
    async fnChangeStatus(status) {
      const payload = {
        ...this.cashData[this.tabIndex - 1],
        account_status: status,
        account_reason: this.reason,
        quantity: this.cashData[this.tabIndex - 1].quantity_a,
        total: this.cashData[this.tabIndex - 1].total_a,
        // money_denominations: this.cashData[this.tabIndex - 1].accountant_list
        money_denominations: this.rows.map(item => {
          return {
            ...item,
            quantity: item.quantity_a.toString(),
            total: item.total_a.toString()
          }
        })
      }
      await updateCashList(payload)
        .then(res => {
          this.$message({
            type: 'success',
            message: 'Cập nhật thành công'
          })
        })
        .catch(error => {
          this.$message({
            type: 'error',
            message: this.$t(
              'errorMsg.' + error?.response?.data?.message
                ? error?.response?.data?.message
                : error
            )
          })
        })
        .finally(() => {
          this.dialogConfirmVisible = false
          this.dialogFormVisible = false
          this.onSearch()
        })
    },
    async fnGetPermissionToConfirm() {
      const userInfo = localStorage.getItem('')
      await getPermissionToConfirm({
        accountId: this.$store.state.user.id
      }).then(res => {
        const data = res.data
        if (data === undefined || data === null) return
        hasConfirmPermission = data.some(item => {
          return item.code === 'CASH_STATEMENT_CONFIRM' && item.inUse === true
        })
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.customm-button {
  background-color: #357456;
  color: #fff;
  padding: 8px 20px;
  font-size: 14px;
  font-weight: 700;
  border-radius: 20px;
  cursor: pointer;
  border: none;
}
</style>
